// Mood Presets for the homepage pitch background.
// Each preset defines colors for: sky, grass stripes, veil overlay, floodlight visibility.
export const MOOD_PRESETS = {
  giorno: {
    id: "giorno",
    label: "Giorno soleggiato",
    icon: "sun",
    sky: "linear-gradient(180deg, #7dd3fc 0%, #38bdf8 22%, #bae6fd 42%, #86efac 56%, #22c55e 100%)",
    grass: "repeating-linear-gradient(90deg, #22c55e 0 90px, #16a34a 90px 180px)",
    veil: "linear-gradient(180deg, rgba(255,255,255,0.78), rgba(255,255,255,0.86) 45%, rgba(255,251,235,0.82))",
    floodlightOpacity: 0.15,
    sunVisible: true,
    crowdBrightness: 1.15,
  },
  notte: {
    id: "notte",
    label: "Notte stadio",
    icon: "moon",
    sky: "linear-gradient(180deg, #0b1e3d 0%, #1e3a8a 22%, #6a3c6b 40%, #123214 55%, #0f2a17 100%)",
    grass: "repeating-linear-gradient(90deg, #1c8f4d 0 90px, #167a41 90px 180px)",
    veil: "linear-gradient(180deg, rgba(255,255,255,0.82), rgba(255,255,255,0.88) 45%, rgba(255,255,255,0.82))",
    floodlightOpacity: 1,
    sunVisible: false,
    crowdBrightness: 1,
  },
  allenamento: {
    id: "allenamento",
    label: "Allenamento",
    icon: "dumbbell",
    sky: "linear-gradient(180deg, #64748b 0%, #94a3b8 28%, #cbd5e1 46%, #f97316 55%, #4b8b5c 66%, #3a6b48 100%)",
    grass: "repeating-linear-gradient(90deg, #4b8b5c 0 90px, #3f7a4d 90px 180px)",
    veil: "linear-gradient(180deg, rgba(255,247,237,0.82), rgba(255,255,255,0.86) 45%, rgba(255,237,213,0.80))",
    floodlightOpacity: 0.45,
    sunVisible: false,
    crowdBrightness: 0.9,
  },
};

// Auto-detect preset from current local time.
// 06:00–17:00 → giorno; 17:00–20:00 → allenamento; 20:00–06:00 → notte.
export function autoPresetFromTime(date = new Date()) {
  const h = date.getHours();
  if (h >= 6 && h < 17) return "giorno";
  if (h >= 17 && h < 20) return "allenamento";
  return "notte";
}

const STORAGE_KEY = "fife.moodPreset";
const AUTO_KEY = "fife.moodAuto";

export function loadStoredPreset() {
  try {
    const auto = localStorage.getItem(AUTO_KEY);
    if (auto === null || auto === "1") {
      return { id: autoPresetFromTime(), auto: true };
    }
    const id = localStorage.getItem(STORAGE_KEY);
    if (id && MOOD_PRESETS[id]) return { id, auto: false };
    return { id: autoPresetFromTime(), auto: true };
  } catch {
    return { id: autoPresetFromTime(), auto: true };
  }
}

export function storePreset(id, auto) {
  try {
    localStorage.setItem(AUTO_KEY, auto ? "1" : "0");
    if (!auto) localStorage.setItem(STORAGE_KEY, id);
  } catch {}
}
